import {  httpGet } from '@/tool/request/index';

//获取每日上报统计列表
export async function xcxTaskEverydayReport(data: any) {
  return await httpGet<any>('/xcx/task/everyday/report')({
    data,
  });
}